import { Space, Slider } from 'antd';
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from "@ant-design/icons";
import { DatePicker } from 'antd';
import React, { useState, useEffect } from 'react';
import { get } from "../Libraries/Ajax/HttpService";
import { Spin } from 'antd';
import {
    XAxis,
    YAxis,
    Legend,
    CartesianGrid,
    Line,
    Tooltip,
    LineChart,
    ResponsiveContainer,

} from "recharts";
import { useDistrict } from "../utils/DistrictContext";

function Outlierovertime(data) {
   const navigate = useNavigate();
    const [loading, setloading] = useState(false);



    const [myData, setmyData] = useState([]);

    const [slvalue, setSlvalue] = useState(data.slvalue);
    const { RangePicker } = DatePicker;
    const { selectedDistrict } = useDistrict();
    // const arryDatas = [];


    const onselectClick = () => {
        // history.push('/stats');

    }

    const onselectClicks = () => {
        navigate('/outliers');

    }
    const onselectClickss = () => {
        navigate('/outliersnew');

    }

    const onRedirection = (event) => {

        // history.push('/dashboard');
        // window.history.back();
        navigate(-1);
    }
    useEffect(() => {
        console.log(data.data);
        getData()
    }
        , [data.data.parameterone, data.data.parametertwo, data.data.defaultOption, data.data.slvalue,selectedDistrict])

    const getData = async () => {
        if (data.data.defaultOption == "Custom" && data.data.parameterone != undefined && data.data.parametertwo != undefined) {
            setloading(true);

            get(`apis/outliers_time/new?start_date=${data.data.parameterone}&end_date=${data.data.parametertwo}&minimum_score=${data.data.slvalue}&option=${data.data.defaultOption}`).then(
                (res) => {

                    console.log("Outlierovertime", res.data.outliers_by_meter);
                    // res.data.outliers_by_meter.forEach((x) => {
                    //     let Obj = {
                    //         name: x.flow_time_date,
                    //         names: x.flow_time_month,
                    //         Excluded: x.exclude_count,
                    //         Included: x.include_count,

                    //     };
                    //     arryDatas.push(Obj);
                    // });
                    // setmyData(arryDatas);
                    const arryDatas = res.data.outliers_by_meter.map((x) => ({
                    name: x.flow_time_date,
                    names: x.flow_time_month,
                    Excluded: x.exclude_count,
                    Included: x.include_count,
                    }));

                    setmyData(arryDatas);

                    console.log(myData);
                    setloading(false);
                }
            );

        }
        else {
            setloading(true);

            get(`apis/outliers_time/new?&minimum_score=${data.data.slvalue}&option=${data.data.defaultOption}`).then(
                (res) => {

                    console.log("Outlierovertime", res.data.outliers_by_meter);
                    // res.data.outliers_by_meter.forEach((x) => {
                    //     let Obj = {
                    //         name: x.flow_time_date,
                    //         names: x.flow_time_month,
                    //         Excluded: x.exclude_count,
                    //         Included: x.include_count,

                    //     };
                    //     arryDatas.push(Obj);
                    // });
                    // setmyData(arryDatas);
                     const arryDatas = res.data.outliers_by_meter.map((x) => ({
                     name: x.flow_time_date,
                     names: x.flow_time_month,
                     Excluded: x.exclude_count,
                     Included: x.include_count,
                       }));

                     setmyData(arryDatas);

                    console.log(myData);
                    setloading(false);
                }
            );


        }





    }

    return (
        <>
            {/* <Header /> */}
            {/* <Main> */}
            {/* <div>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex fs-30 gap-3">
                            <ArrowLeftOutlined onClick={onRedirection} />
                            <h3 className="my-4">Outliers</h3>
                        </div>
                        <div className='d-flex gap-3'>
                            <div className="fs-26 fw-bold d-flex gap-3">
                                <select name="All meters" id="selector" className="box" onChange={onMouseClick} >
                                    <option value="Past Year" >Past Year</option>
                                    <option value="Past 3 Months" >Past 3 Months </option>
                                    <option value="Past Month">Past Month</option>
                                    <option value="Past Week" selected>Past Week</option>
                                    <option value="Past Day">Past Day</option>
                                    <option value="Custom">Custom</option>
                                </select>

                            </div>
                            <Space direction="horizontal" size={1} className="">

                                {defaultOption === "Custom" ? <RangePicker onChange={onchange}  separator={<SwapOutlined />} /> : ""}

                            </Space>
                        </div>
                    </div>
                </div>

                <div className="fs-20 fw-bold d-flex gap-3 d-flex align-items-center justify-content-between flex-wrap">
                    <div className='d-flex gap-3 flex-wrap'>
                        <div className="px-3 py-1 bg-white border rounded align-self-center c-pointer"
                            onClick={onselectClicks}
                        >
                            Outlier By Meter
                        </div>
                        <div className="px-3 py-1 bg-white border rounded align-self-center c-pointer"
                            onClick={onselectClickss}
                        >Outliers
                        </div>
                        <div className="px-3 py-1 text-blue bg-white border border-info rounded align-self-center c-pointer"
                            onClick={onselectClick}
                        >
                            Outliers Over Time
                        </div>
                    </div>
                    <div className="fw-bold d-flex gap-1000 ">
                        <div className="float-right">
                            <h6 className='fs-14'>Filter By Minimum Absolute Standard Score</h6>
                            <Slider defaultValue={10} disabled={false} max={100} onChange={sliderChange} />

                        </div>
                    </div>
                </div> */}
            {/* <div className="row row-cols-4 mt-4 g-3">
                    <div className="col-12 col-lg">
                        <div className="trend">
                            <p className="text-grey">Matching Outliers</p>
                            <span> {matching}</span>
                        </div>
                    </div>
                    <div className="col-12 col-lg">
                        <div className="trend">
                            <p className="text-grey">Points</p>
                            <span> {point} </span>
                        </div>
                    </div>
                    <div className="col-12 col-lg">
                        <div className="trend">
                            <p className="text-grey">Outliers</p>
                            <span className="text-red">{outliers}%</span>
                        </div>
                    </div> */}
            {/* <div className="col-12 col-lg">
                        <div className="trend">
                            <p className="text-grey">Inactive Metes</p>
                            <span className="text-red">0</span>
                        </div>
                    </div> */}
            {/* </div><br /> */}

            <div className="bottom-layout">

                {loading === false ?
                    <div style={{ maxWidth: "96%", margin: "0 auto", height: "500px", position: "relative" }} >

                        <ResponsiveContainer>
                            <LineChart
                                data={myData}
                                // margin={{ top: 25, right: 25, bottom: 25, left: 0 }}
                                margin={{
                                    top: 5,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                }}
                            >
                                {(data.data.defaultOption==="Past Year")?
                               
                                <><XAxis xAxisId="0" dataKey="name" tick={false} textAnchor="end" />
                                <XAxis dataKey="names" xAxisId="1"  textAnchor="end" allowDuplicatedCategory={false}
                                //  angle={-45} textAnchor="end"
                                /></>: <XAxis xAxisId="0" dataKey="name" textAnchor="end" allowDuplicatedCategory={false}/>}
                                {/* <XAxis dataKey="name" />
                                <XAxis dataKey="names" /> */}
                                <YAxis />
                                <Legend />
                                <Line type="monotone"
                                    dataKey="Excluded"
                                    isAnimationActive={false}
                                    name="Excluded"
                                    fill="#488ac7"
                                    stroke="#93ffe8"

                                >

                                </Line>
                                <Line type="monotone"
                                    dataKey="Included"
                                    isAnimationActive={false}
                                    name="Included"
                                    fill="#43c6db"
                                    stroke="#6699CC"
                                >

                                </Line>
                                <CartesianGrid stroke="lightGrey" />
                                <Tooltip />

                            </LineChart>

                        </ResponsiveContainer>
                        <div className='labelYAxis3'>Count</div>
                    </div>

                    : <div className="example"><Spin /></div>}
            </div>

            {/* </Main> */}

        </>
    );

}


export default Outlierovertime;